export const appName = 'treuhandsuche';

export const apiUrl = process.env.REACT_APP_API_URL;

export const GOOGLE_ANALYTICS_KEY = process.env.REACT_APP_GOOGLE_ANALYTICS_KEY
